import gql from 'graphql-tag'
import {useQuery} from 'react-apollo'

const VIEWER = gql`
  query {
    viewer {
      ... on Client {
        accounts {
          ... on BaseAccount {
            id
          }
        }
        id
      }
    }
  }
`
export const useViewer = () => {
  const {loading, data} = useQuery(VIEWER)

  const viewer = data?.viewer

  return {
    loading,
    viewer,
  }
}
